import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IUnitDefault } from "../../Types"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipSailsViewProps } from "./Params"

// Sails. Detail-level section (the container renders whenever detail level is on).
export function PrintShipSailsView({ data }: PrintShipSailsViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = includeShipDataType === ShipDataType.details;

  return (
    <PrintListBlock title={t("sails")} visible={visible}>
      {shipData?.sails && shipData.sails.length > 0 && shipData.sails.map((sail, index) => (
        <BlockRow key={sail.id || index}className="block-row-one-row-list">
          <BlockField label={t("sail")} className="block-field-90">{sail.sail ? (predefined.sail.includes(sail.sail) ? t(`sail_${sail.sail}`) : sail.sail) : sail.sail}</BlockField>
          <BlockField label={t("sail_type")} className="block-field-90">{sail.sailType ? (predefined.sailType.includes(sail.sailType) ? t(`sail_${sail.sailType}`) : sail.sailType) : sail.sailType}</BlockField>
          <BlockField label={t("sail_reefs_no")} className="block-field-90">{sail.reefNo !== undefined ? t(`sail_${sail.reefNo}`) : sail.reefNo}</BlockField>
          <BlockField label={t("sail_size")} className="block-field-75">{sail.size} {sail.sizeUnit || (sail.size ? IUnitDefault.surface : "")}</BlockField>
          <BlockField label={t("manufacturer")} className="block-field-210">{sail.manufacturer}</BlockField>
          <BlockField label={t("comment")} className="">{sail.comment}</BlockField>
        </BlockRow>
      ))}
    </PrintListBlock>
  );
}
